import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import { ConstrainedText } from '~components/Text';

// Page Navigation
import PageNav from '~components/PageNav';
import CellReplacementCard from '~components/PageCard/CellReplacementCard';
import StemCellTherapiesCard from '~components/PageCard/StemCellTherapiesCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO
        title="Le projet de financement du DT1 donne des résultats positifs en matière de thérapie modificatrice"
        desc="Description"
      />
      <Hero title="Le projet de financement du DT1 donne des résultats positifs en matière de thérapie modificatrice">
        <StaticImage style={heroImgStyles} src="../../images/t1d-fund-project-feature.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        ImmunoMolecular Therapeutics, Inc. (« IM Therapeutics »), chef de file en matière de médicaments pour les maladies auto-immunes, vient de lancer une étude clinique de phase 1b à dose multiple ascendante. Cette étude auprès de patients touchés par le diabète de type 1 (DT1) qui ont également des traits génétiques spécifiques connus sous le nom de HLA-DQ8, présents dans environ 60 % des patients atteints par le DT1. Les variants dans certains gènes, appelés des antigènes d’histocompatibilité humains (HLA) sont reconnus pour jouer un rôle important dans l’activation d’une réponse auto-immune.
        </ConstrainedText>
        <ConstrainedText>
        L’essai de la phase 1b recrutera 30 patients âgés de 18 à 45 ans (qui vivent aux États-Unis) et comparera le médicament par rapport au placebo pour l’innocuité, la tolérabilité et les profils pharmacocinétiques (PK) pour un dosage d’une durée de deux semaines avec un suivi d’une semaine après la fin de la dose. En outre, l’étude évaluera l’activité pharmacodynamique (PD) à l’aide d’un test sanguin qui mesure la capacité de l’IMT-002 à bloquer la présentation des « auto-antigènes » ou des protéines propres à l’organisme, telles que l’insuline ou le gluten, qui peuvent engendrer l’auto-immunité.
        </ConstrainedText>
        <ConstrainedText>
        La conclusion de l’étude de la phase 1 chez les personnes en bonne santé et celles atteintes de DT1 a démontré des résultats sécuritaires. Les résultats indiquent une forte possibilité d’éventuellement n’avoir recours qu’à une seule thérapie orale quotidienne pour les patients qui ont eu un diagnostic récent de DT1, dont plus de la moitié sont des enfants. Le médicament a également le potentiel d’aider les patients atteints d’autres maladies auto-immunes, notamment la maladie cœliaque et l’arthrite.
        </ConstrainedText>
        <ConstrainedText>
        Lancé en décembre 2016, le Fonds DT1 a été conçut pour créer un nouveau marché d’investissement visant à fournir des solutions aux personnes vivant avec ou à risque de développer le DT1.
        </ConstrainedText>
        <ConstrainedText>
        Le fonds est aujourd’hui l’un des plus grands fonds philanthropiques du monde axé sur une maladie, avec 100 millions de dollars d’actifs afin de générer des investissements privés pour sécuriser les milliards nécessaires pour générer des traitements. Merci du soutien remarquable que nous avons reçu de nos donateurs du Canada pour faire avancer le travail du Fonds DT1.
        </ConstrainedText>
        <PageNav previous={<CellReplacementCard />} next={<StemCellTherapiesCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
